/**
 * Round once to cents. Shared base for every displayed/derived currency
 * figure that needs to reconcile to the cent — used by the rate-comparison
 * widget's OTA price math (`widgets/rate-comparison/pricing.ts`) and the
 * booking widget's fee-line reshape (`widgets/booking/fee-line-separator.ts`).
 */
export const roundToCents = (amount: number): number => Math.round(amount * 100) / 100
